module.exports = __webpack_public_path__ + "media/images/default/shared/footer/bg-xl-8697134afd05eb45fb160fa764570b5c.svg";